import React, { useState, useEffect } from "react";
import Companies from "../../Components/Home/Company";
import Bills, { Module, removeBill } from "../../Components/Payment/Bills";
import Chart from "../../Components/UsageManagement/Chart";
import { getBills } from "../../Screens/Payment/Payment";
import { connect } from "react-redux";
import InnerHeader from "../../Components/Common/InnerHeader";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
import moment from "moment-jalaali";
export const getBillHistory = (billId, token, setHistoryBill) => {
  ApiCall(
    "get",
    `${urls.GetBillHistory}${billId}`,
    null,
    "GethistoryBills",
    token,
    function(e) {
      const getDate = bill => {
        var date;
        if (bill.bill_company_id === 1) {
          date = bill.info.CurrentDate;
        } else if (bill.bill_company_id === 2) {
          date = bill.info.CurrentReadingDate;
        } else if (bill.bill_company_id === 3) {
          date = bill.info.CurrentReadingDate;
        } else if (bill.bill_company_id === 4) {
          date = moment(bill.updated_at).format("jYYYY / jM / jD");
        } else if (bill.bill_company_id === 5) {
          date = moment(bill.updated_at).format("jYYYY / jM / jD");
        }
        return date;
      };
      setHistoryBill(
        e.data
          .filter(i => i.end_of_period === 1)
          .map(i => {
            return { amount: i.amount, date: getDate(i) };
          })
      );
    },
    function(error) {
      console.log(error);
    }
  );
};

function UsageManagment({ token, isLogin }) {
  const [companyId, setCompanyId] = useState(0);
  const [bills, setBills] = useState([]);
  const [billId, setBillId] = useState("");
  const [historyBill, setHistoryBill] = useState("");
  const [, setBillName] = useState("");
  const [moduleID, setModuleID] = useState("");
  const [, setBillsLoading] = useState(true);
  useEffect(() => {
    getBillHistory(billId, token, setHistoryBill);
  }, [billId, token]);

  useEffect(() => {
    setBillId("");
    setHistoryBill("");
    companyId !== 0 &&
      window.scrollTo({
        top: document.getElementById("ChooseBillId").offsetTop,
        behavior: "smooth"
      });
  }, [companyId]);
  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) getBills(setBills, token, setBillsLoading);
    return () => (isSubscribed = false);
  }, [token]);
  useEffect(() => {
    setBillId("");
  }, [companyId]);
  useEffect(() => {
    historyBill !== "" &&
      document.getElementById("ChartId") &&
      window.scrollTo({
        top: document.getElementById("ChartId").offsetTop,
        behavior: "smooth"
      });
  }, [historyBill]);
  const filteredBills =
    bills && bills.filter(i => i.bill_company_id === companyId);
  return (
    <div className="container useageManagment">
      <InnerHeader isLogin={isLogin} />

      <img
        id="userManageImage"
        src={require("../../assets/images/Usage.jpeg")}
        alt=""
      />
      <h3>برای مشاهده جزئیات مصرف نوع قبض را مشخص کنید</h3>
      <Companies onClick={setCompanyId} selectedId={companyId} />
      {companyId !== 0 && (
        <>
          <h3 style={{ color: "#ec4d11" }} id="ChooseBillId">
            {filteredBills.length > 0
              ? "لطفا شناسه مورد نظر را انتخاب نمایید"
              : "تا کنون قبضی پرداخت نکرده اید"}
          </h3>
          <Bills
            usage={true}
            bills={filteredBills}
            billsLoading={false}
            onClick={setBillId}
            onClickName={setBillName}
            setModuleID={setModuleID}
          />
        </>
      )}
      {historyBill.length > 0 && <Chart data={historyBill} />}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    isLogin: state.auth.isLogin
  };
};

export default connect(mapStateToProps)(UsageManagment);
